// src/Components/LoginModal.js

import React, { useEffect, useState } from "react";
import { useAuth } from "../../../Context/authContext";
import { useModal } from "../../../Context/modalContext";
import { Modal, Form, Input, Button, Typography, notification } from "antd";

const LoginModal = ({ visible, onCancel, intendedRoute }) => {
  const { auth, login, resetPassword } = useAuth();
  const { isLoading, isAuthenticated } = auth;
  const [resetState, setResetState] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [fieldError, setFieldError] = useState("");
  const { hideModal } = useModal();

  // Reset field error when inputs change
  const resetFieldError = () => setFieldError("");
  const handleFormSwap = () => {
    setResetState(!resetState);
    resetFieldError();
  };
  // Input validation
  const validateInput = (username, password) => {
    if (!username || !password) {
      setFieldError("Please enter both username and password.");
      notification.error({
        message: "Validation Error",
        description: "Please enter both username and password.",
        placement: "topRight",
        duration: 3,
      });
      return false;
    }
    return true;
  };

  // Notifications
  const showSuccessNotification = () => {
    notification.success({
      message: "Login Successful",
      // description: "You have successfully logged in.",
      placement: "topRight",
      duration: 3,
    });
  };

  const showErrorNotification = (message) => {
    notification.error({
      message: "Login Failed",
      description: message,
      placement: "topRight",
      duration: 5,
    });
  };

  // Effect to handle post-authentication actions
  useEffect(() => {
    if (isAuthenticated) {
      const freshLogin = localStorage.getItem("freshLogin");
      if (freshLogin === "true") {
        showSuccessNotification();
        hideModal();

        localStorage.removeItem("freshLogin");
      }
    }
  }, [isAuthenticated, hideModal]);

  // Handle form submission
  const handleLogin = async (e) => {
    e.preventDefault();
    resetFieldError();

    // Basic input validation
    if (!validateInput(username, password)) return;

    try {
      await login(username, password);
      // Assume the login function updates `isAuthenticated` upon success
    } catch (err) {
      const errorMessage =
        err.response?.data?.detail || "Login failed. Please try again.";
      showErrorNotification(errorMessage);
    }
  };
  const handleResetPassword = async (email) => {
    try {
      await resetPassword(email);
      notification.success({
        message: "Password Reset Email Sent",
        description: "Please check your email for further instructions.",

        placement: "topRight",
        duration: 5,
      });
      hideModal();
    } catch (err) {
      const errorMessage =
        err.response?.data?.detail ||
        "Password reset failed. Please try again.";
      showErrorNotification(errorMessage);
    }
  };

  return (
    <Modal
      centered
      open={true}
      footer={null}
      closable={false}
      maskClosable={true}
      onCancel={hideModal}
      destroyOnClose
    >
      <div className="form-modal">
        {/* Login Form */}
        {!resetState && (
          <>
            <div className="login-header-wrapper">
              <Typography.Title level={3} className="login-header">
                Login
              </Typography.Title>
              <Typography.Text className="login-sub">
                Login with your YouthPlus credentials
              </Typography.Text>
            </div>
            {fieldError && (
              <p className="error-message" style={{ color: "red" }}>
                {fieldError}
              </p>
            )}

            <Form layout="vertical" onSubmitCapture={handleLogin}>
              <Form.Item label="Username" required>
                <Input
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your username"
                />
              </Form.Item>
              <Form.Item label="Password" required>
                <Input.Password
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                />
              </Form.Item>
              <Form.Item>
                <Button
                  className="login-button"
                  type="primary"
                  htmlType="submit"
                  style={{ backgroundColor: "#08839B", width: "100%" }}
                  loading={isLoading}
                >
                  {isLoading ? "Logging in..." : "Login"}
                </Button>
              </Form.Item>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div onClick={handleFormSwap}>Forgot Password</div>
                <div>
                  Don't have an account?
                  <span>
                    {" "}
                    <a
                      style={{ textDecoration: "none", color: "#08839B" }}
                      href="http://www.youthplus.ng"
                    >
                      Sign up
                    </a>
                  </span>
                </div>
              </div>
            </Form>
          </>
        )}
        {resetState && (
          <>
            <div className="login-header-wrapper">
              <Typography.Title level={3} className="login-header">
                Reset Password
              </Typography.Title>
              <Typography.Text className="login-sub">
                Enter your email to reset your password
              </Typography.Text>
            </div>
            <Form
              layout="vertical"
              onFinish={(values) => handleResetPassword(values.email)}
            >
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please enter your youthplus email.",
                  },
                  { type: "email", message: "Please enter a valid email." },
                ]}
              >
                <Input placeholder="Enter your email" />
              </Form.Item>
              <Form.Item>
                <Button
                  className="login-button"
                  type="primary"
                  htmlType="submit"
                  style={{ backgroundColor: "#08839B", width: "100%" }}
                  loading={isLoading}
                >
                  {isLoading ? "Loading" : "Reset Password"}
                </Button>
              </Form.Item>
            </Form>
          </>
        )}
      </div>
    </Modal>
  );
};

export default LoginModal;
